/**
 * Theme constants for IELTS components
 * Centralized color palette and styling values
 */

export const themeColors = {
  primary: '#996CFE',
  primaryHover: '#7C4DFF',
  primaryLight: '#E8DFFF',
  primaryLighter: '#F8F2FF',
  primaryLightest: '#FAFAFA',
  background: '#F5F6FA',
  backgroundAlt: '#F0F0F0',
  border: '#E0E0E0',
  borderLight: '#E8DFFF',
  text: '#333',
  textSecondary: '#666',
  textLight: '#999',
  success: '#37965E',
  successLight: '#E8F5E9',
  error: '#E53935',
  errorLight: '#FFF3F3',
  errorRed: '#FF5252',
  white: '#FFF',
  scrollbarThumb: '#c0c0c0',
  scrollbarTrack: '#f1f1f1',
  scrollbarThumbHover: '#a0a0a0',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
};

export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  full: '50%',
};

export const shadows = {
  sm: '0px 1px 3px rgba(0, 0, 0, 0.05)',
  md: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  lg: '0px 4px 12px rgba(0, 0, 0, 0.05)',
  xl: '0px 4px 24px rgba(153,108,254,0.10)',
};

export const sectionColors = {
  listening: {
    primary: '#868EAF',   // PTE Listening color
    light: '#D1D4E0',
    lighter: '#E8EAF0',
    hover: '#6B7280',
  },
  reading: {
    primary: '#AD826E',   // PTE Reading color
    light: '#D4C4B8',
    lighter: '#E9DFD8',
    hover: '#8F6B58',
  },
  writing: {
    primary: '#FF5D5D',   // PTE Writing color
    light: '#FFB3B3',
    lighter: '#FFE0E0',
    hover: '#E63939',
  },
  speaking: {
    primary: '#49D7F2',   // PTE Speaking color
    light: '#A8EBF8',
    lighter: '#D9F5FC',
    hover: '#2BC4E0',
  },
};


/**
 * Get section color by category name
 * @param {string} categoryName - Category name (Listening, Reading, Writing, Speaking)
 * @returns {Object} Section color object
 */
export const getSectionColor = (categoryName) => {
  if (!categoryName) return sectionColors.listening;
  const normalized = categoryName.toLowerCase();
  if (normalized.includes('listening')) return sectionColors.listening;
  if (normalized.includes('reading')) return sectionColors.reading;
  if (normalized.includes('writing')) return sectionColors.writing;
  if (normalized.includes('speaking')) return sectionColors.speaking;
  return sectionColors.listening; // default
};

